import type { Contact } from '@/services/CloudSync/cloudSyncPlanService'
import type { PlanData } from '@/types'

const contactFields = [
	'firstName',
	'middleName',
	'lastName',
	'address',
	'city',
	'state',
	'zip',
	'phone',
	'email',
	'leadId',
] as const

export const planToContact = (plan: Partial<PlanData>): Contact => {
	return {
		firstName: plan.firstName,
		middleName: plan.middleName,
		lastName: plan.lastName,
		address: plan.address,
		city: plan.city,
		state: plan.state,
		zip: plan.zip,
		phone: plan.phone,
		email: plan.email,
		leadId: plan.leadId,
		opportunityId: plan.opportunityId,
		contactId: plan.contactId,
	} as Contact
}

/**
 * Compare contact (cardInfo) with selected plan to see if any field is different
 */
export const cardWasEdited = (
	plan: Partial<PlanData>,
	contact: Contact
): boolean => {
	return contactFields.some((field) => plan[field] !== contact[field])
}

export const getUnusedContacts = (
	plans: Partial<PlanData>[],
	contactList: Contact[]
) => {
	return contactList.filter((contact) => {
		return !plans.find((plan) => isSameContact(plan, contact))
	})
}

export const isSameContact = (plan: Partial<PlanData>, contact: Contact) => {
	const matchedOnContactId =
		contact.contactId && contact.contactId === plan.contactId
	const matchedOnName =
		contact.firstName === plan.firstName && contact.lastName === plan.lastName

	return matchedOnContactId || matchedOnName
}
